import { makeClosedTask, makeOptions, normalizeMay2026Variant, pick } from "../../../../matura/MaturaMay2026ClosedTaskSupport";

function greatestCommonDivisor(left, right) {
  let a = Math.abs(left);
  let b = Math.abs(right);

  while (b !== 0) {
    [a, b] = [b, a % b];
  }

  return a || 1;
}

export function formatReducedExponent(numerator, denominator) {
  const divisor = greatestCommonDivisor(numerator, denominator);
  const reducedNumerator = numerator / divisor;
  const reducedDenominator = denominator / divisor;

  if (reducedDenominator === 1) {
    return String(reducedNumerator);
  }

  return `\\frac{${reducedNumerator}}{${reducedDenominator}}`;
}

function powerLatex(base, numerator, denominator) {
  return `${base}^{${formatReducedExponent(numerator, denominator)}}`;
}

export function buildNestedPowerDistractors(item) {
  const denominator = item.innerIndex * item.outerIndex;

  return [
    powerLatex(item.base, 1, denominator),
    powerLatex(item.base, item.wholePower, item.outerIndex),
    powerLatex(
      item.base,
      item.wholePower * item.innerIndex + item.outerIndex,
      denominator
    ),
  ];
}

export function task03(variant) {
  const original = { base: 5, outerIndex: 2, innerIndex: 2, wholePower: 1 };
  const pool = [
    { base: 2, outerIndex: 2, innerIndex: 2, wholePower: 1 },
    { base: 3, outerIndex: 2, innerIndex: 2, wholePower: 1 },
    { base: 7, outerIndex: 2, innerIndex: 2, wholePower: 1 },
    { base: 11, outerIndex: 2, innerIndex: 2, wholePower: 1 },
    { base: 2, outerIndex: 3, innerIndex: 2, wholePower: 1 },
    { base: 3, outerIndex: 3, innerIndex: 2, wholePower: 1 },
    { base: 5, outerIndex: 3, innerIndex: 2, wholePower: 2 },
    { base: 7, outerIndex: 3, innerIndex: 2, wholePower: 2 },
    { base: 2, outerIndex: 2, innerIndex: 3, wholePower: 1 },
    { base: 3, outerIndex: 2, innerIndex: 3, wholePower: 1 },
    { base: 5, outerIndex: 3, innerIndex: 3, wholePower: 1 },
    { base: 7, outerIndex: 3, innerIndex: 3, wholePower: 1 },
  ];
  const item = variant === "original" ? original : pick(pool);
  const numerator = item.wholePower * item.innerIndex + 1;
  const denominator = item.innerIndex * item.outerIndex;
  const result = powerLatex(item.base, numerator, denominator);
  const originalOptions = [["A", "5^{\\frac{1}{4}}"], ["B", "5^{\\frac{1}{2}}"], ["C", "5^{\\frac{3}{4}}"], ["D", "5"]];
  const wrong = buildNestedPowerDistractors(item);
  const { options, correctIndex } = makeOptions(result, wrong, variant === "original" ? originalOptions : null);
  const outerRoot = item.outerIndex === 2 ? "\\sqrt{" : "\\sqrt[" + item.outerIndex + "]{";
  const innerRoot = item.innerIndex === 2 ? "\\sqrt{" : "\\sqrt[" + item.innerIndex + "]{";
  const powerPart = item.wholePower === 1 ? String(item.base) : item.base + "^{" + item.wholePower + "}";
  return makeClosedTask({
    type: "MaturaNestedRootPowerClosedTask",
    taskNumber: "3",
    variant,
    tags: ["pierwiastki", "potegi"],
    data: {
      instruction: "Dokończ zdanie. Wybierz właściwą odpowiedź spośród podanych.",
      prompt: "Liczba jest równa:",
      latex: outerRoot + powerPart + innerRoot + item.base + "}}",
      options,
      correctIndex,
      explanationTitles: ["Zapisujemy pierwiastki w postaci potęg o wykładnikach wymiernych.", "Mnożymy wykładniki wynikające z kolejnych pierwiastków."],
        explanationLines: [
        powerPart + "\\cdot " + item.base + "^{\\frac{1}{" + item.innerIndex + "}}=" + item.base + "^{\\frac{" + numerator + "}{" + item.innerIndex + "}}",
        "\\left(" + item.base + "^{\\frac{" + numerator + "}{" + item.innerIndex + "}}\\right)^{\\frac{1}{" + item.outerIndex + "}}=" + result,
      ],
    },
  });
}

export function generateTask(options = {}) {
  return task03(normalizeMay2026Variant(options));
}

export { checkClosedAnswer as checkAnswer, renderClosedAnswer as renderAnswer, renderClosedExplanation as renderExplanation, renderClosedInput as renderInput, renderClosedTask as renderTask, renderClosedUserAnswer as renderUserAnswer } from "../../../../matura/MaturaMay2026ClosedTaskSupport";
